var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 20,
  x: 5,
  y: 2,
  rx: 0.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.42 6.22a.49.49 0 0 1 0-.44L19 2.72a.5.5 0 0 0-.5-.72h-8a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.72Z"
})));
export default SvgFlag;